import React, { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import db, { storage } from "./Firebase";

const UploadGrowForm = () => {
    const [formData, setFormData] = useState({
        category: "diy_post",
        image_url: "",
        name: "Post",
        paid: true,
        status: "1",
    });
    const [image, setImage] = useState(null);
    const [uploading, setUploading] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (!image) {
            alert("Please select an image.");
            return;
        }
        setUploading(true);
        const imageRef = ref(storage, `images/${image.name}`);
        try {
            const uploadTask = uploadBytesResumable(imageRef, image);
            await uploadTask;
            const downloadURL = await getDownloadURL(imageRef);
            setFormData({ ...formData, image_url: downloadURL });
            alert("Image uploaded successfully!");
        } catch (error) {
            console.error("Error uploading image:", error);
            alert("Error uploading image.");
        }
        setUploading(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, "nv_cards"), {
                ...formData,
                created_date: serverTimestamp(),
            });
            alert("Data uploaded successfully!");
            setFormData({
                category: "",
                image_url: "",
                name: "",
                paid: true,
                status: "",
            });
            setImage(null);
        } catch (error) {
            console.error("Error adding document:", error);
            alert("Error submitting data.");
        }
    };

    return (
        <div style={{ maxWidth: "400px", margin: "0 auto", padding: "20px" }}>
            <h2>Upload e-Invite Data</h2>
            <form onSubmit={handleSubmit}>
                {/* <div>
                    <label>Category:</label>
                    <input
                        type="text"
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        required
                    />
                </div> */}

                <div>
                    <label>Image:</label>
                    <input type="file" accept="image/*" onChange={handleImageChange} />
                    <button type="button" onClick={handleUpload} disabled={uploading}>
                        {uploading ? "Uploading..." : "Upload Image"}
                    </button>
                    {formData.image_url && (
                        <div>
                            <img src={formData.image_url} alt="Uploaded" width="100" />
                        </div>
                    )}
                </div>

                {/* <div>
                    <label>Name:</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div> */}

                <div>
                    <label>Paid:</label>
                    <input
                        type="checkbox"
                        name="paid"
                        checked={formData.paid}
                        onChange={handleChange}
                    />
                </div>

                {/* <div>
                    <label>Status:</label>
                    <input
                        type="text"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        required
                    />
                </div> */}

                <button type="submit" disabled={uploading}>
                    Submit
                </button>
            </form>
        </div>
    );
};

export default UploadGrowForm;
